import { useState } from "react";
import { TradeHistoryBot } from "./TradeHistoryBot";
import { LogBot } from "./LogBot";

export default function TableHeader() {
  const [activeTab, setActiveTab] = useState("history");
  const tabBaseStyle =
    "pb-2 cursor-pointer text-base focus:outline-none transition-all duration-150 ease-in-out";

  const activeTabSpecificStyle = "font-semibold border-b-2 border-black";

  const inactiveTabSpecificStyle =
    "font medium text-gray-500 hover:text-gray-700";

  return (
    <div className="flex flex-col bg-white rounded-xl py-7 px-5">
      <div className="flex space-x-8 z-10">
        <div
          className={`${tabBaseStyle}
            ${
              activeTab === "history"
                ? activeTabSpecificStyle
                : inactiveTabSpecificStyle
            }`}
          onClick={() => setActiveTab("history")}
        >
          Trade History
        </div>
        <div
          className={`${tabBaseStyle}
            ${
              activeTab === "botlog"
                ? activeTabSpecificStyle
                : inactiveTabSpecificStyle
            }`}
          onClick={() => setActiveTab("botlog")}
        >
          Bot Log
        </div>
      </div>
      <div className="md:-mt-6">
        {activeTab === "history" && <TradeHistoryBot />}
        {activeTab === "botlog" && <LogBot />}
      </div>
    </div>
  );
}
